import { WORKFLOW_README_STUB } from "../../shared/mutators/createWorkflow";

export function isUntouchedReadmeStub(file: {
  path: string;
  blob: { content: string } | undefined;
}): boolean {
  return (
    file.path === "README.md" &&
    file.blob?.content.trim() === WORKFLOW_README_STUB.trim()
  );
}
